import * as React from 'react'
import { connect } from 'react-redux'
import { PhoneLinesListComponent } from './PhoneLinesList'
import { replace } from 'react-router-redux'
import { reduxForm } from 'redux-form'
import { flow } from 'lodash'

const form = 'phoneLinesList'

export interface IPhoneLinesListContainerProps {
  page: number
  ban?: string
  type?: string
  search?: string
}

const stateToProps = ({ billing }, { ban, type, search }: IPhoneLinesListContainerProps) => ({
  banOptions: [
    { name: 'Any', value: '' },
    ...billing.billingAccounts.map(account => ({
      name: `${account.ban} - ${account.name}`,
      value: account.ban,
    })),
  ],
  initialValues: {
    ban,
    type,
    search,
  },
})

export const dispatchToProps = {
  replace,
}

export const PhoneLinesList = flow<any, any, React.SFC<IPhoneLinesListContainerProps>>(
  reduxForm({ form, enableReinitialize: true }),
  connect(stateToProps, dispatchToProps)
)(PhoneLinesListComponent)



// WEBPACK FOOTER //
// src/features/PhoneLines/PhoneLinesList/PhoneLinesList.container.ts